<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn v-if="create_access" color="primary" class="mb-5" dark @click="openCreate">
        {{ $t("Crear") }} Centro de Costo
      </v-btn>

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-6 pt-0">
                  <v-radio-group v-model="selected_status" row class="mt-0 mb-0">
                    <v-radio label="Habilitado" :value="true"></v-radio>
                    <v-radio label="No habilitado" :value="false"></v-radio>
                    <v-radio label="Todos" value="all"></v-radio>
                  </v-radio-group>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="loadData">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Tabla de Centros -->
      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ descending: true, itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.enabled ? 'SI' : 'NO' }}</td>
              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="openEdit(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="create_access" v-on="on" small color="green" class="mr-2" @click="openClone(props.item)">content_copy</v-icon>
                  </template>
                  <span>Clonar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="confirmDelete(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <!-- Modal Centro de Costo -->
      <ModalCostCenter
        :dialog="dialog_cc"
        :item="current_cc"
        modal_title="Centro de Costo"
        @updateDialog="dialog_cc = $event"
        @loadList="loadData"
      />

      <DialogDelete
        :dialog_delete="dialog_delete"
        @updateDialogDelete="dialog_delete = $event"
        @deleteItemConfirm="deleteItemConfirm"
      />

      <!-- Dialog Clonar -->
      <v-dialog v-model="dialog_clone" max-width="450px" @click:outside="dialog_clone = false">
        <v-card>
          <v-card-title class="headline">Clonar Centro de Costo</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="clone_name"
              label="Nombre del nuevo Centro de Costo*"
              autofocus
              @keyup.enter="confirmClone"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog_clone = false">Cancelar</v-btn>
            <v-btn color="success" text :loading="clone_loading" @click="confirmClone">Clonar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import ModalCostCenter from "./Modal.vue";

export default {
  components: { Title, DialogDelete, ModalCostCenter },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      page_title: "Centros de Costos",
      list: [],
      search: "",
      selected_status: true,
      dialog_cc: false,
      current_cc: { id: "", name: "", enabled: true },
      dialog_delete: false,
      item_to_delete: null,
      dialog_clone: false,
      clone_name: "",
      clone_loading: false,
      cc_to_clone: null,
      headers: [
        { text: "Nombre", value: "name", align: "left", sortable: true },
        { text: "Habilitado", value: "enabled", align: "left", sortable: true },
        { text: "Acción", value: "", align: "center", sortable: false },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const filters = { enabled: this.selected_status === "all" ? undefined : this.selected_status };
        const response = await generalService.filter(filters, Constant.SECTION_COSTS_CENTERS);
        this.list = response.result || [];
      } catch (e) {
        console.error("loadData error", e);
      } finally {
        this.loading = false;
      }
    },

    openCreate() {
      this.current_cc = { id: "", name: "", enabled: true };
      this.dialog_cc = true;
    },
    openEdit(cc) {
      this.current_cc = { ...cc };
      this.dialog_cc = true;
    },
    openClone(cc) {
      this.cc_to_clone = cc;
      this.clone_name = cc.name + " (Copia)";
      this.dialog_clone = true;
    },
    async confirmClone() {
      if (!this.clone_name || !this.clone_name.trim()) {
        this.$toast.error("Debe ingresar un nombre.", "Error");
        return;
      }
      this.clone_loading = true;
      try {
        const response = await generalService.query(
          { id: this.cc_to_clone.id, name: this.clone_name.trim() },
          Constant.SECTION_COSTS_CENTERS + "/clone"
        );
        if (response.status) {
          this.$toast.success("Centro de costo clonado correctamente.", "OK");
          this.dialog_clone = false;
          this.loadData();
        } else {
          this.$toast.error(response.msg, "Error");
        }
      } catch {
        this.$toast.error("Error al clonar el centro de costo.", "Error");
      } finally {
        this.clone_loading = false;
      }
    },
    confirmDelete(cc) {
      this.item_to_delete = cc;
      this.deleteId = cc.id;
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      generalService
        .remove({ id: this.deleteId }, Constant.SECTION_COSTS_CENTERS)
        .then((response) => {
          if (response.status) {
            this.$toast.success("Eliminado correctamente.", "OK");
            this.loadData();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch(() => this.$toast.error("Error al eliminar.", "Error"))
        .finally(() => {
          this.dialog_delete = false;
          this.item_to_delete = null;
        });
    },
  },
};
</script>
